module.exports = __webpack_public_path__ + "img/logo-fysson.ea3493f9.png";